import axios from "axios";

// Operações rápidas: o pinpad responde em segundos. Se passar disso, o serviço
// local travou e é melhor cair no catch (que leva para PAGAMENTO_FALHOU) do que
// deixar a tela parada indefinidamente.
const TIMEOUT_CURTO_MS = 30000;

// Operações que esperam o cliente agir (encostar o cartão, pagar o Pix). Aqui o
// timeout é generoso de propósito: derrubar cedo uma transação que o cliente
// ainda está concluindo seria pior que esperar.
const TIMEOUT_AGUARDA_CLIENTE_MS = 180000;

const instance = axios.create({
  baseURL: "http://localhost:9001/",
  timeout: TIMEOUT_CURTO_MS,
  headers: {
    "Content-Type": "application/json;charset=utf-8",
    "Access-Control-Allow-Origin": "*",
  },
});

export default {
  getComprovante() {
    return instance.get("/v1/pinpad/reimpressao");
  },
  cancelarPagamento() {
    return instance.get("/v1/pinpad/cancelar-transacao");
  },
  gerarPagamento(formaPagamento, valorPagamento) {
    return instance.post(
      "v1/pinpad/pagar",
      {
        formaPagamento: formaPagamento,
        valor: valorPagamento,
      },
      { timeout: TIMEOUT_AGUARDA_CLIENTE_MS }
    );
  },
  gerarPix(valorPagamento) {
    return instance.post("v1/pinpad/gerar-qrcode", {
      formaPagamento: "PIX",
      valor: valorPagamento,
    });
  },
  aguardandoPagamentoPix(id) {
    return instance.post(
      "v1/pinpad/aguardando-pagamento-pix",
      { id: id },
      { timeout: TIMEOUT_AGUARDA_CLIENTE_MS }
    );
  },
  pagamentoNfc({ authToken, posEid, productCode, quantity }) {
    return instance.post("payment/nfc", {
      authToken: authToken,
      posEid: posEid,
      productCode: productCode,
      quantity: quantity,
    });
  },
};
